import { publicAxios } from "./axiosInstance";

const login = async (email, password) => {
  try {
    const response = await publicAxios.post("/Auth/Login", { email, password });

    return response;
  } catch (error) {
    throw error;
  }
};

export default login;
